import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

// https://v2.chakra-ui.com/docs/components/checkbox/theming
const baseStyle = definePartsStyle({
    control: {
        borderRadius: 3,
        borderWidth: 0.5,
        borderColor: 'brand.aubergine',
        _checked: {
            bg: 'brand.aubergine',
            borderColor: 'brand.aubergine',
        },
    },
    icon: {
        padding: 0.25,
    },
    container: {
        width: '100%',
        px: 4,
        py: 3,
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        borderRadius: 'lg',
        borderColor: 'brand.grey',
        borderWidth: 0.5,
        borderStyle: 'solid',
        _hover: {
            cursor: 'pointer',
            borderColor: 'brand.aubergine',
            color: 'brand.aubergine',
        }
    },
    label: {
        fontSize: 'md',
        marginInlineStart: 0,
    },      
});

export const CheckboxConfig = defineMultiStyleConfig({ baseStyle });
